'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  GOOGLE_AUTHENTICATOR: null,
  SMS: null,
  HUBSPOT_AUTHENTICATOR: null
});